import { initializeApp } from "firebase/app";
import { getMessaging,isSupported  } from "firebase/messaging";

const firebaseConfig = {
   apiKey: "AIzaSyBKt8_wjI1q5HPiCixAKSBIL-VQ3tC-cow",
  authDomain: "mpe-comms.firebaseapp.com",
  projectId: "mpe-comms",
  storageBucket: "mpe-comms.firebasestorage.app",
  messagingSenderId: "937229417662",
  appId: "1:937229417662:web:eb7e01c9ab594f54e8f2ef"
};

const firebaseApp = initializeApp(firebaseConfig);

const getFirebaseMessaging = async () => {
  const supported = await isSupported();
  if (!supported) {
    console.warn("Firebase Messaging not supported in this browser.");
    return null;
  }
  return getMessaging(firebaseApp);
};

export { firebaseApp, getFirebaseMessaging };